<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='other_find_current_limit_list'
      params>
      <div>
        <span class='left-table'>参数名称：</span>
        <el-input v-model='name' placeholder='请输入参数名称' style='width: 200px;'></el-input>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>
        <span class='left-table'>
          <el-button type='success' icon='el-icon-circle-plus' @click='showAdd'>增加</el-button>
        </span>
      </div>
    </icare-table>
    <!-- 编辑信息 -->
    <el-dialog :title='editTip' :visible.sync='editVisible' width='50%' @closed='closeDialog'>
      <el-form ref='form' :model='form' :rules='rules' label-width='200px'>
        <el-form-item label='参数名称' :label-width='formLabelWidth' prop='name'>
          <el-input v-model='form.name'></el-input>
        </el-form-item>
        <el-form-item label='最大电流' :label-width='formLabelWidth' prop='max_current'>
          <el-input v-model.number='form.max_current'>
            <template slot='append'>mA</template>
          </el-input>
        </el-form-item>

        <el-form-item label='浮充电流' :label-width='formLabelWidth' prop='float_current'>
          <el-input v-model.number='form.float_current'>
            <template slot='append'>mA</template>
          </el-input>
        </el-form-item>

        <el-form-item label='电流突增' :label-width='formLabelWidth' prop='rise_current'>
          <el-input v-model.number='form.rise_current'>
            <template slot='append'>mA</template>
          </el-input>
        </el-form-item>


        <el-form-item label='浮充时长' :label-width='formLabelWidth' prop='float_time'>
          <el-input v-model.number='form.float_time'>
            <template slot='append'>秒</template>
          </el-input>
        </el-form-item>

      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='closeDialog'>取 消</el-button>
        <el-button type='primary' @click='save'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { getCookie } from '@/utils/auth'


export default {
  data() {
    let self = this
    return {
      loading: false,
      name: '',
      tableParams: {
        id: null,
        name: null
      },
      titleConfig: [
        {
          field: 'name',
          title: '参数名称',
          visible: true
        },
        {
          field: 'max_current',
          title: '最大电流(mA)',
          visible: true,
          fuc: val => {
            return (val)
          }
        },
        {
          field: 'float_current',
          title: '浮充电流(mA)',
          visible: true,
          fuc: val => {
            return (val)
          }
        },
        {
          field: 'rise_current',
          title: '电流突增(mA)',
          visible: true,
          fuc: val => {
            return val
          }
        },
        {
          field: 'float_time',
          title: '浮充时长(秒)',
          visible: true,
          fuc: val => {
            return (val)
          }
        },
        {
          field: 'created_at',
          title: '创建时间',
          visible: true
        },
        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            {
              title: '编辑',
              color: '#67C23A',
              icon: 'el-icon-edit-outline',
              fuc: this.showEdit
            },
            {
              title: '删除',
              color: '#F56C6C',
              icon: 'el-icon-delete',
              fuc: row => {
                this.delete(row)
              }
            }
          ]
        }
      ],

      //编辑信息
      editTip: '',
      form: {
        id: null
      },
      rules: {
        name: [
          { required: true, message: '请输入站点名称', trigger: 'blur' }
        ],
        charge_type_id: [
          { required: true, message: '请输入收费标准', trigger: 'change' }
        ],
        charge_type: [
          { required: true, message: '请输入收费方式', trigger: 'change' }
        ],
        province: [
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        city: [
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        district: [
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        street: [
          { max: 50, message: '输入的文字过长，长度应在 50 个字符内', trigger: 'blur' }
        ]
      },

      formLabelWidth: '100px',
      editVisible: false
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {

  },
  methods: {
    //弹出编辑(新增)对话框
    showAdd() {
      this.dialogType = 1
      this.editVisible = true
      this.editTip = '新增信息'
      this.form ={}
    },
    //弹出编辑(新增)对话框
    showEdit(row) {
      this.dialogType = 2
      this.editVisible = true
      this.editTip = '编辑信息'
      this.form = Object.assign({}, row)
    },
    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.form = {}
      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },
    //模糊搜索
    find() {
      this.tableParams.name = this.name
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'other_remove_current_limit',
          params: str
        }).then((res) => {
         console.log(res)
         if(res.code==10004){
            this.$message.warning('删除失败,已被使用')
          }
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },

    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let func = 'other_add_current_limit'
          if (this.dialogType === 2) {
            func = 'other_update_current_limit'
          }
          let form = Object.assign({}, this.form)
          let str = JSON.stringify(form)
          gateway({
            func: func,
            params: str
          }).then(() => {
            this.closeDialog()
            this.$refs.table.refresh()
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

.amap-demo {
  height: 400px;
}
</style>
